idIsValid